import { AlertCircle, CheckCircle2, CircleEllipsis, Info, X, XCircle } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { AlertProps } from './types';

import { Button } from '../button';
import { Icon } from '../icon';

export const Alert = ({ ref, ...props }: AlertProps) => {
  const { className, children, type = 'neutral', onClose, ...other } = props;
  const { alert } = useTheme();

  let icon;
  switch (type) {
    case 'success':
      icon = CheckCircle2;
      break;
    case 'warning':
      icon = XCircle;
      break;
    case 'error':
      icon = AlertCircle;
      break;
    case 'info':
      icon = Info;
      break;
    case 'neutral':
    default:
      icon = CircleEllipsis;
  }

  const cls = twMerge(alert.base, alert[type], onClose && alert.withClose, className);

  const iconCls = twMerge(alert.icon.base, alert.icon[type], 'absolute top-0 left-0 mt-4 ml-4');
  const closeCls = twMerge(
    alert.icon.base,
    alert.icon[type],
    'hover:bg-gray-overlay/10 focus:ring-primary-medium absolute top-0 right-0 mt-4 mr-4'
  );

  return (
    <div className={cls} role="alert" ref={ref} {...other}>
      {onClose && <Button icon={X} className={closeCls} size="xs" as="link" aria-label="close" onClick={onClose} />}
      <Icon icon={icon} className={iconCls} />
      {children}
    </div>
  );
};
